import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { of } from 'rxjs'
import { map, filter } from 'rxjs/operators'
import { CalendarService } from 'src/app/pages/calendar/services/calendar.service';

@Component({
  selector: 'app-attention',
  templateUrl: './attention.component.html',
  styleUrls: ['./attention.component.scss'],
})

export class AttentionComponent implements OnInit {
  public date = undefined;
  public meet = undefined;

  constructor(
    private httpSv: HttpService,
    private calendarSv: CalendarService
  ) { }

  ngOnInit() {
    this.getSchedule(undefined);
    this.calendarSv.emitNewDate.subscribe(data => {
      const date = new Date(data);
      this.getSchedule(date);
    })
  }

  async getSchedule(date){
    date = date || new Date();
    const params = {
      month: date.getMonth(),
      year: date.getFullYear()
    }
    const dataDiary = await this.httpSv.itemIndex('attentionSchedule', '', params, 'diary');
    of(dataDiary)
      .pipe(
        map((res) => {
          return res.data;
        }),
        filter((res) => {
          const filtered = res.order.filter((item: any) => item.date);
          res.order = filtered;
          const dataOrder = res;
          dataOrder.order.map(item => {
            const splitedDate = item.date.split('T')
            const hour = splitedDate[1];
            const date = splitedDate[0].replace(/-/g, '/');
            item.endHour = hour;
            item.endTime = hour;
            item.startHour = hour;
            item.startTime = hour;
            item.date = date;
          })
          return res;
        }),
        map(res => {
          return {data: res, actualDate: date};
        })
      ).subscribe((res: any) => {
        this.meet = res.data.order;
        this.date = res;
      })
  }

}
